import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index.vue')
  },
  {
    path: '/recommend',
    name: 'recommend',
    component: () => import('@/views/recommend/recommend.vue')
  },
  {
    path: '/sixgallery',
    name: 'sixgallery',
    component: () => import('@/views/sixgallery/sixgallery.vue')
  },
  {
    path: '/series',
    name: 'series',
    component: () => import('@/views/series/series.vue')
  },
  {
    path: '/series-details',
    name: 'series-details',
    component: () => import('@/views/series/series-details.vue')
  },
  
  {
    path: '/toolChest',
    name: 'toolChest',
    component: () => import('@/views/toolChest/toolChest.vue')
  },
  {
    path: '/49',
    name: '49',
    component: () => import('@/views/49/49.vue')
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('@/views/statistics/statistics.vue')
  },
  {
    path: '/consultation',
    name: 'consultation',
    component: () => import('@/views/consultation/consultation.vue')
  },
  {
    path: '/118',
    name: '118',
    component: () => import('@/views/118/118.vue')
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/history/history.vue')
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('@/views/details/details.vue')
  },
  {
    path: '/down', 
    name: 'down',
    component: () => import('@/views/down/down.vue')
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
